export function bootComplete(state) {
  state.isBooting = false;
}

export function blockInteraction(state) {
  state.canInteract = false;
}
export function allowInteraction(state) {
  state.canInteract = true;
}

export function setLanguage(state, { language }) {
  state.language = language;
}

export function setLocation(state, location) {
  state.location = location;
}

export function setAll(state, all) {
  state.all = all;
}

export function updateLocationConfig(state, config) {
  state.locationConfig = config;
}
